import './assets/sass/styles.scss';
import 'vue-notifyjs/themes/default.scss';
import 'animate.css';
import './assets/images/favicon.ico';
import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
import VueApollo from 'vue-apollo';
import VueNotify from 'vue-notifyjs';
import App from './App.vue';
import router from './router';
import VeeValidate from 'vee-validate';
import PortalVue from 'portal-vue';
import moment from 'moment';
import Color from 'color';
import Helpers from './utils/helpers';
import { graphqlClient, apolloClient } from './apollo';
import feather from 'vue-icon';
import { store } from './store/store';
import { sync } from 'vuex-router-sync';
import BackendService from './services/BackendService';
import 'pikaday/css/pikaday.css';
import mixins from './utils/mixins';
import './registerComponents';
import { provide } from '@vue/composition-api';
import { ApolloClients } from '@vue/apollo-composable';
moment.locale('pt');

window.Popper = require('popper.js');

const backendService = new BackendService();
const unsync = sync(store, router);

Vue.use(VueApollo);
Vue.use(VueCompositionApi);
Vue.use(VueNotify, {
  type: 'primary',
  timeout: 2500,
  horizontalAlign: 'center',
  verticalAlign: 'top',
});
Vue.use(VeeValidate);
Vue.use(PortalVue);
Vue.use(require('vue-chartist'));
Vue.use(feather);

Object.defineProperty(Vue.prototype, '$moment', {
  value: moment,
});

Object.defineProperty(Vue.prototype, '$color', {
  value: Color,
});

Object.defineProperty(Vue.prototype, '$helpers', {
  value: Helpers,
});

const apolloProvider = new VueApollo({
  clients: {
    first: graphqlClient,
    second: apolloClient,
  },
  defaultClient: apolloClient,
  defaultOptions: {
    $query: { fetchPolicy: 'cache-and-network' },
  },
});

function init() {
  new Vue({
    setup() {
      provide(ApolloClients, {
        default: apolloClient,
        first: graphqlClient,
      });
    },
    el: '#app',
    router,
    store,
    apolloProvider,
    render: (h) => h(App),
    mixins: [mixins],
    mounted() {
      this.$router.beforeEach((to, from, next) => {
        this.$store.commit('hideMenu');
        this.$store.commit('hideSideBar');
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          // this route requires auth, check if logged in
          // if not, redirect to login page.
          if (!backendService.isLoggedIn()) {
            next({
              path: '/login',
              query: {
                redirect: to.fullPath,
              },
            });
          } else {
            next();
          }
        }
        next();
      });

      // force first redirect
      if (!backendService.isLoggedIn()) {
        router.replace('/login');
      }
    },
  });

  console.log('%c(▀̿Ĺ̯▀̿ ̿) You looking at me?', 'color:#000; font-size: 32px');
}

// Wait for the deviceready event to start the render
document.addEventListener('deviceready', () => {
  console.log('Ready, Render the App');
  init();
});

// If we are not in Cordova, manually trigger the deviceready event
const isCordovaApp = typeof window.cordova !== 'undefined';
if (!isCordovaApp) {
  document.dispatchEvent(new CustomEvent('deviceready', {}));
}



// WEBPACK FOOTER //
// ./src/main.js